import { NetworkRequest } from "api/actions";

export const getAlerts = (): NetworkRequest => {
    return {
        type: "NETWORK_REQUEST",
        method: "GET",
        url: "/api/alerts/outages"
    };
};
